enum EControlLifeCycleEvents {
	Init = 'onInit',
	DataLoad = 'onDataLoad',
	Load = 'onLoad',
	EndRequest = 'onEndRequest',
	RequestError = 'onRequestError',
	PreRender = 'onPreRender',
	Render = 'onRender'
}

export default EControlLifeCycleEvents;
